

//render tabs
const Subscribe = ()=>{
    
    return (
        <p>render the amount to collect </p>
    )
}

export default Subscribe;